module.exports = __webpack_public_path__ + "img/ico-building.e134ab69.svg";